import ActivityEquity from './ActivityEquity';

export default (props) => {
  return <ActivityEquity {...props} />;
};
